import { gql } from '@apollo/client';
import type { TrainingVideo, TrainingVideosByCategory, UserTrainingMedia, UUID } from '@cobliteam/common-types';
import type { MutationUpdateUserTrainingMediaArgs, UpdateUserTrainingMediaInput, UserTrainingMediaActionType } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';
import {
  graphQlTrainingVideosByCategoryToTrainingVideoByCategory,
  graphQlTrainingVideoToTrainingVideo,
  graphQlUserTrainingMediaToUserTrainingMedia,
} from './TrainingVideoTransformer';

class GraphQLTrainingVideoRequester {
  public getTrainingVideos = (): Promise<TrainingVideo[]> => {
    return graphQLRequester
      .query<{ trainingVideos: TrainingVideo[] }>({
        query: gql`
          query trainingVideos {
            trainingVideos {
              id
              categoryId
              url
              thumbnail
              name
              description
            }
          }
        `,
      })
      .then((graphQlResponse) => graphQlResponse.trainingVideos.map(graphQlTrainingVideoToTrainingVideo));
  };

  public getAllTrainingVideosByCategory = (): Promise<TrainingVideosByCategory[]> => {
    return graphQLRequester
      .query<{ trainingVideosByCategory: TrainingVideosByCategory[] }>({
        query: gql`
          query trainingVideosByCategory {
            trainingVideosByCategory {
              category {
                name
                title
                subtitle
              }
              trainingVideos {
                id
                categoryId
                url
                thumbnail
                name
                description
              }
            }
          }
        `,
      })
      .then((graphQlResponse) => graphQlResponse.trainingVideosByCategory.map(graphQlTrainingVideosByCategoryToTrainingVideoByCategory));
  };

  public getUserTrainingMedia = (): Promise<UserTrainingMedia[]> => {
    return graphQLRequester
      .query<{ userTrainingMedia: UserTrainingMedia[] }>({
        query: gql`
          query UserTrainingMedia {
            userTrainingMedia {
              userId
              trainingMediaId
              startedAt
              finishedAt
              createdAt
            }
          }
        `,
      })
      .then((graphQlResponse) => graphQlResponse.userTrainingMedia.map(graphQlUserTrainingMediaToUserTrainingMedia));
  };

  public updateUserTrainingMedia = (trainingMediaId: UUID, action: UserTrainingMediaActionType): Promise<UserTrainingMedia> => {
    const updateUserTrainingMediaInput: UpdateUserTrainingMediaInput = {
      trainingMediaId: trainingMediaId,
      action: action,
    };

    return graphQLRequester
      .mutate<{ updateUserTrainingMedia: UserTrainingMedia }, MutationUpdateUserTrainingMediaArgs>({
        mutation: gql`
          mutation UpdateUserTrainingMedia(
            $input: UpdateUserTrainingMediaInput!
          ) {
            updateUserTrainingMedia(input: $input) {
              createdAt
              finishedAt
              startedAt
              trainingMediaId
              userId
            }
          }
        `,
        variables: {
          input: updateUserTrainingMediaInput,
        },
      })
      .then();
  };
}

export default GraphQLTrainingVideoRequester;
